import React from "react";

export const Email = React.forwardRef<SVGSVGElement, React.SVGAttributes<SVGElement>>(function Email(props, ref) {
	return (
		<svg ref={ref} fill="currentColor" {...props}>
			<use xlinkHref="#icon-e-mail"></use>
		</svg>
	);
});
